import { ChangeDetectionStrategy, Component, ElementRef, input, model, output, Signal, viewChild } from '@angular/core';
import { DsModalModule } from '@bmw-ds/components';

import { Customer } from '../../../customer/model/customer.model';
import { modalOpenOrClosing } from '../../../utils/signal/modalOpenOrClosing';
import { CreateBmwMiniIdContainer } from './create-bmw-mini-id.container';

@Component({
  selector: 'cdf-create-bmw-mini-id-wrapper',
  imports: [DsModalModule, CreateBmwMiniIdContainer],
  template: `
    <ds-modal [ds-modal-trigger-for]="eci" [(isModalOpen)]="isModalOpen" size="sm" #eci>
      <ds-box-content>
        @if (openOrClosing()) {
          <cdf-create-bmw-mini-id-container
            [customer]="customer()"
            (closeModal)="isModalOpen.set(false)"
            (successfullyInitializedIdCreation)="successfullyInitializedIdCreation.emit()"
          />
        }
      </ds-box-content>
    </ds-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateBmwMiniIdWrapper {
  readonly isModalOpen = model(false);
  readonly customer = input<Customer>();
  readonly successfullyInitializedIdCreation = output();

  readonly modal: Signal<ElementRef<HTMLElement>> = viewChild.required('eci', { read: ElementRef });
  protected readonly openOrClosing = modalOpenOrClosing(this.isModalOpen, this.modal);
}
